export const TORAPPU_ENDPOINT = "https://torappu.prts.wiki";
export const STATIC_ENDPOINT = "https://static.prts.wiki";
export const PRTS_BASE_DOMAIN = "https://prts.wiki";
export const KEY_STRING =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+,";
export const MEDIA_ENDPOINT = "https://media.prts.wiki";
export const WEEDY_ENDPOINT = "https://weedy.prts.wiki";
